var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 122.88",
    style: {
      enableBackground: "new 0 0 122.88 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.44,0c16.97,0,32.33,6.88,43.44,18c11.12,11.12,18,26.48,18,43.44c0,16.97-6.88,32.33-18,43.44 c-11.12,11.12-26.48,18-43.44,18S29.11,116,18,104.88C6.88,93.77,0,78.41,0,61.44C0,44.47,6.88,29.11,18,18 C29.11,6.88,44.47,0,61.44,0L61.44,0z M77.05,36.16c-0.6-0.56-1.28-0.85-2.05-0.81c-0.77,0-1.45,0.3-2.01,0.9l-4.53,4.7L81.15,53.2 l4.57-4.78c0.56-0.55,0.77-1.28,0.77-2.05c0-0.77-0.3-1.49-0.85-2.01L77.05,36.16L77.05,36.16L77.05,36.16z M53.31,82.11 c-1.67,0.56-3.37,1.07-5.04,1.62c-1.67,0.56-3.33,1.11-5.04,1.67c-3.97,1.28-6.15,2.01-6.62,2.14c-0.47,0.13-0.17-1.71,0.81-5.55 l3.16-12.09l0.26-0.27L53.31,82.11L53.31,82.11L53.31,82.11L53.31,82.11z M45.45,64.83L65.04,44.5l12.68,12.21L57.92,77.3 L45.45,64.83L45.45,64.83z M101.08,21.8C90.93,11.66,76.92,5.39,61.44,5.39S31.95,11.66,21.8,21.8 C11.66,31.95,5.39,45.96,5.39,61.44c0,15.48,6.27,29.49,16.42,39.64c10.14,10.14,24.16,16.42,39.64,16.42s29.49-6.27,39.64-16.42 c10.14-10.14,16.42-24.16,16.42-39.64C117.49,45.96,111.22,31.95,101.08,21.8L101.08,21.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6bbc05e72ac9867f4efb0d7a36f9fd73.svg";
export { ForwardRef as ReactComponent };